import React, { useState, useContext, useEffect } from 'react';
import moment from 'moment';
import { getPendingList, getListOrderGoods } from '../../services/Order';
import { getListContractGoods } from '../../services/Contract';
import { getGoodsPriceList } from '../../services/Supplier';
import {
  InputNumber,
  Row, Col,
  Divider,
  Tag,
  Button,
  Checkbox,
  Form, Input, Select, DatePicker, Dropdown,
  Space, AutoComplete,
  message, Popover
} from 'antd';
import {
  WarningOutlined,
  CloseOutlined,
  SearchOutlined,
  CaretUpOutlined,
  PlusOutlined,
  CaretDownOutlined,
  PlusCircleOutlined,
  CheckOutlined,
  CheckCircleOutlined, CheckCircleTwoTone
} from '@ant-design/icons';
import { MasterContext } from '../../App';

import './style';

export default React.forwardRef((props, ref) => {
  const { warehouse, user } = useContext(MasterContext);
  const { mode, suppliers, contract, onCloseCallback, onSaveCallback } = props;
  const [isOrderDisabeled, setOrderDisabled] = useState(false);

  const [pendingList, setPendingList] = useState([]);
  const [orderGoods, setOrderGoods] = useState(contract ? contract.goods || [] : []);
  const [isSingleSupplier, setSingleSupplier] = useState(contract ? contract.single_supplier : true);
  const [orderId, setOrderId] = useState(contract ? contract.order_id : undefined);
  const [addtionals, setAddtionals] = useState(contract ? contract.addtionals && contract.addtionals.split(';').filter(x => x.length > 0) || [] : []);
  const [ownerId, setOwnerId] = useState(contract ? contract.owner_id : undefined);
  const [date, setDate] = useState(contract ? moment(contract.date, 'YYYY-MM-DD') : moment(new Date, 'YYYY-MM-DD'));
  const [warehouseId, setWarehouseId] = useState(contract ? contract.warehouse_id : '');
  const [deliveryDeadlineDate, setDeliveryDeadlineDate] = useState(contract ? moment(contract.delivery_deadline_date, 'YYYY-MM-DD') : undefined);
  const [isAddtionalInputVisible, setAddtionalInputVisible] = useState(false);
  const [form] = Form.useForm();
  const [shipmark, setShipmark] = useState(contract ? contract.shipmark : undefined);

  const [supplierId, setSupplierId] = useState(undefined);
  const [supplierIds, setSupplierIds] = useState([]);

  const [orderDate, setOrderDate] = useState(contract ? moment(contract.date, 'YYYY-MM-DD') : undefined);
  const [orderDeliveryDeadlineDate, setOrderDeliveryDeadlineDate] = useState(contract ? moment(contract.delivery_deadline_date, 'YYYY-MM-DD') : undefined);

  const [supplierPrices, setSupplierPrices] = useState({});
  const addAddtional = (e) => {
    const arr = [].concat(addtionals);
    if (e.target) {
      e.preventDefault();
      arr.push(e.target.value);
    } else {
      arr.push(e);
    }
    setAddtionals(arr);
    setAddtionalInputVisible(false);
  }

  const onChangeSupplier = (id, index) => {
    if (!supplierPrices.hasOwnProperty(id)) {
      getGoodsPriceList(id).then(data => {
        supplierPrices[id] = data;
        setSupplierPrices(supplierPrices);
        if (index < 0) {
          const temp = orderGoods.map((item, index) => {
            const currentPrice = data.find(
              x => x.goods_id === item.id && x.goods_spec_id === item.spec_id && moment(x.start_time).isBefore(moment(new Date()))
                && moment(new Date()).isBefore(moment(x.end_time)));
            return Object.assign({
              supplier_id: id, goods_spec_price: currentPrice.price, goods_spec_price_ts: currentPrice.start_time
            }, item);
          })
          setOrderGoods(temp);
        } else {
          const item = orderGoods[index];
          const currentPrice = data.find(
            x => x.goods_id === item.id && x.goods_spec_id === item.spec_id && moment(x.start_time).isBefore(moment(new Date()))
              && moment(new Date()).isBefore(moment(x.end_time)));
          setSupplierIds(supplierIds);
          orderGoods[index] =
            Object.assign({
              supplier_id: id, goods_spec_price: currentPrice.price, goods_spec_price_ts: currentPrice.start_time
            }, orderGoods[index]);
          const temp = [].concat(orderGoods);
          setOrderGoods(temp);
        }
      });
    } else {
      const data = supplierPrices[id];
      if (index < 0) {
        const temp = orderGoods.map((item, index) => {
          const currentPrice = data.find(
            x => x.goods_id === item.id && x.goods_spec_id === item.spec_id && moment(x.start_time).isBefore(moment(new Date()))
              && moment(new Date()).isBefore(moment(x.end_time)));
          return Object.assign({
            supplier_id: id, goods_spec_price: currentPrice.price, goods_spec_price_ts: currentPrice.start_time
          }, item);
        })
        setOrderGoods(temp);
      } else {
        const item = orderGoods[index];
        const currentPrice = data.find(
          x => x.goods_id === item.id && x.goods_spec_id === item.spec_id && moment(x.start_time).isBefore(moment(new Date()))
            && moment(new Date()).isBefore(moment(x.end_time)));
        orderGoods[index] = Object.assign({
          supplier_id: id, goods_spec_price: currentPrice.price, goods_spec_price_ts: currentPrice.start_time
        }, orderGoods[index]);
        const temp = [].concat(orderGoods);
        setOrderGoods(temp);
      }
    }
    if (index < 0) {
      setSupplierId(id);
    } else {
      supplierIds[index] = id;
      const temp = [].concat(supplierIds);
      setSupplierIds(temp);
    }
  }

  const onChangeRemark = (e, index) => {
    const temp = [].concat(orderGoods);
    temp[index].remark = e.target.value;
    setOrderGoods(temp);
  }

  const onChangeOrder = (id) => {
    const order = pendingList.find(x => x.id === id);
    if (!order) return;
    getListOrderGoods(id).then(data => {
      setOrderGoods(data);
    });
    setOrderId(id);
    setShipmark(order.shipmark);
    setOrderDate(moment(order.date, 'YYYY-MM-DD'));
    setOrderDeliveryDeadlineDate(moment(order.delivery_deadline_date, 'YYYY-MM-DD'));
  }
  const onChangeNoBuyer = (e) => {
    if (e.target.checked) {

    } else {

    }
    setOrderDisabled(e.target.checked);
  }
  const deleteAddtional = (e) => {
    const arr = [].concat(addtionals);
    arr.splice(e, 1);
    setAddtionals(arr);
  }
  const onClose = async () => {
    try {
      if (onCloseCallback) {
        onCloseCallback();
      }
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const getEdit = (values) => {
    values.date = moment(values.date).format('YYYY-MM-DD');
    values.delivery_deadline_date = moment(values.delivery_deadline_date).format('YYYY-MM-DD');

    values.single_supplier = isSingleSupplier;
    values.addtionals = addtionals.join(';');
    const suppliers = [];
    const goods = [];
    if (isSingleSupplier) {
      values.supplier_id = supplierId;
      suppliers.push(Object.assign({
        supplier_id: supplierId
      }, values));
      orderGoods.map((item, index) => {
        if (supplierId) {
          goods.push(
            {
              order_id: values.order_id,
              supplier_id: supplierId,
              idx: item.idx,
              display_order: item.display_order,
              goods_id: item.id,
              goods_spec_id: item.spec_id,
              count: item.count,
              goods_spec_price_ts: item.goods_spec_price_ts,
              goods_spec_price: item.goods_spec_price,
              remark: item.remark
            }
          );
        }
      });
    } else {
      const temp = supplierIds.filter((item, index, supplierIds) => {
        return supplierIds.indexOf(item, 0) === index
      });
      temp.map((id, index) => {
        if (id) {
          suppliers.push(
            Object.assign({
              supplier_id: id
            }, values)
          );
        }
      });
      orderGoods.map((item, index) => {
        if (supplierIds[index]) {
          goods.push(
            {
              order_id: values.order_id,
              supplier_id: supplierIds[index],
              idx: item.idx,
              display_order: item.display_order,
              goods_id: item.id,
              goods_spec_id: item.spec_id,
              count: item.count,
              goods_spec_price_ts: item.goods_spec_price_ts,
              goods_spec_price: item.goods_spec_price,
              remark: item.remark
            }
          );
        }
      });
    }
    return {
      order_contract: suppliers,
      order_contract_goods: goods
    }
  }

  const getNew = (values) => {
    values.date = moment(values.date).format('YYYY-MM-DD');
    values.delivery_deadline_date = moment(values.delivery_deadline_date).format('YYYY-MM-DD');

    values.single_supplier = isSingleSupplier;
    values.addtionals = addtionals.join(';');
    const suppliers = [];
    const goods = [];
    if (isSingleSupplier) {
      values.supplier_id = supplierId;
      suppliers.push(
        Object.assign({
          supplier_id: supplierId
        }, values));
      orderGoods.map((item, index) => {
        if (supplierId) {
          goods.push(
            {
              order_id: values.order_id,
              supplier_id: supplierId,
              idx: item.idx,
              display_order: item.display_order,
              goods_id: item.id,
              goods_spec_id: item.spec_id,
              count: item.count,
              goods_spec_price_ts: item.goods_spec_price_ts,
              goods_spec_price: item.goods_spec_price,
              remark: item.remark
            }
          );
        }
      });
    } else {
      const temp = supplierIds.filter((item, index, supplierIds) => {
        return supplierIds.indexOf(item, 0) === index
      });
      temp.map((id, index) => {
        if (id) {
          suppliers.push(
            Object.assign({
              supplier_id: id
            }, values)
          )
        }
      });
      orderGoods.map((item, index) => {
        if (supplierIds[index]) {
          goods.push(
            {
              order_id: values.order_id,
              supplier_id: supplierIds[index],
              idx: item.idx,
              display_order: item.display_order,
              goods_id: item.id,
              goods_spec_id: item.spec_id,
              count: item.count,
              goods_spec_price_ts: item.goods_spec_price_ts,
              goods_spec_price: item.goods_spec_price,
              remark: item.remark
            }
          );
        }
      });
    }
    return {
      order_contract: suppliers,
      order_contract_goods: goods
    }
  }
  const onSave = async () => {
    try {
      if (!supplierId && (supplierIds || []).length === 0) {
        message.error('请选择供应商！');
        return;
      }
      const values = await form.validateFields();
      console.log('onSave:', values);
      let data = undefined;
      if (mode === 'edit') {
        data = getEdit(values);
      } else {
        data = getNew(values);
      }

      if (onSaveCallback) {
        onSaveCallback(values.order_id, data);
      }
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const options = [
    {
      value: '贴102标签',
    },
    {
      value: 'Downing Street',
    },
    {
      value: 'Wall Street',
    },
  ];

  useEffect(() => {
    var p1 = new Promise((resolve, reject) => {
      getPendingList().then(data => {
        if (mode === 'edit') {
          data.push({
            id: contract.order_id,
            no: contract.order_no,
            po_code: contract.po_code,
            delivery_deadline_date: contract.delivery_deadline_date
          });
        }
        setPendingList(data);
        resolve(true);
      });
    });

    Promise.all([p1]).then(values => {
    });

    if (mode === 'edit') {
      getListOrderGoods(contract.order_id).then(data => {
        getListContractGoods(contract.order_id).then(suppliers => {
          const temp = [];
          (data || []).map((item, index, data) => {
            const supplier = suppliers.find(x => x.idx === item.idx);
            if (supplier) {
              temp[index] = supplier.supplier_id;
              setSupplierId(supplier.supplier_id);
              data[index] =
              Object.assign({
                remark: supplier.remark, supplier_id: supplier.supplier_id, goods_spec_price: supplier.goods_spec_price, goods_spec_price_ts: supplier.goods_spec_price_ts
              }, item)
            }
          });
          setSupplierIds(temp);
          setOrderGoods(data);
        });
      });

    }
  }, []);

  const disabledDate0 = (current) => {
    // Can not select days before today and today
    const deadline = moment(orderDeliveryDeadlineDate);
    return current && (current < moment(orderDate) || current > deadline);
  }

  const disabledDate1 = (current) => {
    // Can not select days before today and today
    const deadline = moment(orderDeliveryDeadlineDate);
    return current && !(current > date && current < deadline);
  }

  const initValue = [
    { name: ['order_id'], value: orderId },
    { name: ['date'], value: date },
    { name: ['delivery_deadline_date'], value: deliveryDeadlineDate },
    { name: ['warehouse_id'], value: warehouseId },
    { name: ['addtionals'], value: addtionals },
    { name: ['owner_id'], value: ownerId },
    { name: ['shipmark'], value: shipmark }
  ];


  const includes = (arr1, arr2) => {
    return arr2.every(val => arr1.includes(val));
  }
  const filterSuppliers = (id) => {
    const temp = orderGoods.map(x => (x.spec_id));
    const order_goods_id = temp.filter((item, index, temp) => {
      return temp.indexOf(item, 0) === index
    });

    const arr = order_goods_id.map(String);
    let arr1 = [];
    if (isSingleSupplier) {
      arr1 = [].concat(suppliers.filter(x => x.goods_count > 0 && includes(x.goods_spec_id.split(','), arr)));
    }
    else {
      arr1 = [].concat(suppliers.filter(x => x.goods_count > 0 && x.goods_spec_id.split(',').indexOf(id + '') > -1));
    }
    return arr1;
  }

  const sum = { count: 0, amount: 0 };
  for (let i = 0; i < orderGoods.length; i++) {
    if (orderGoods[i].count) {
      sum.count += orderGoods[i].count;
      sum.amount += orderGoods[i].count * orderGoods[i].goods_spec_price;
    }
  }
  return (
    <div>
      <Form form={form} preserve={false} onFinish={onSave} fields={initValue} >
        < Divider orientation="left" ><Button type="link" size="small">采购合同信息<CaretDownOutlined /></Button></Divider >
        <Row>
          <Col span={12}>
            <Row>
              <Col span={18}>
                <Form.Item label="订单编号" name="order_id" rules={[{ required: true, message: '请选择所属业务员!' }]}>
                  <Select onChange={(value) => onChangeOrder(value)} disabled={mode === 'edit'} size="small"
                    showSearch="true"
                    placeholder="请选择所订单编号"
                    style={{ width: '100%' }}
                  >
                    {
                      pendingList.map(item => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.no}(#{item.po_code})  -  交货期限[{item.delivery_deadline_date}]
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item>
                  <Checkbox disabled={mode === 'edit'} onChange={onChangeNoBuyer} >库存订单</Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Form.Item label="对接用户" name="owner_id" rules={[{ required: true, message: '请选择所属业务员!' }]}                            >
              <Select
                size="small"
                optionFilterProp="children"
                showSearch="true"
                placeholder="请选择所属业务员"
                onChange={(value) => setOwnerId(value)}
                style={{ width: '100%' }}
              >
                {user.filter(x => x.category_id < 3).map(item => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="签订日期" name="date" rules={[{ required: true, message: '请选择签订日期!' }]}                            >
              <DatePicker size="small" onChange={(value) => setDate(moment(value, 'YYYY-MM-DD'))} disabledDate={disabledDate0} placeholder="请选择签订日期" style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="交货期限" name="delivery_deadline_date" rules={[{ required: true, message: '请选择交货日期!' }]}                            >
              <DatePicker size="small" onChange={(value) => setDeliveryDeadlineDate(moment(value, 'YYYY-MM-DD'))} disabledDate={disabledDate1} placeholder="请选择交货日期" style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="送货地址" name="warehouse_id" rules={[{ required: true, message: '请选择送货地址!' }]}                            >
              <Select onChange={(value) => setWarehouseId(value)} showSearch="true" optionFilterProp="children" placeholder="请选择送货地址" size="small" >
                {warehouse.map(item => (
                  <Select.Option key={item.id} value={item.id}>
                    {`${item.name}-${item.address}`}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="唛头格式" name="shipmark" rules={[{ required: true, message: '请选择唛头格式!' }]}                            >
              <Input.TextArea
                readOnly
                onChange={null}
                placeholder="请输入唛头"
                autoSize={{ minRows: 4, maxRows: 4 }}
              />
            </Form.Item>
            <Form.Item label="　附件条款" name="addtionals" >
              {
                addtionals.map((item, index) => {
                  return <Tag style={{ width: '100%' }} visible={true} closable={true} onClose={() => deleteAddtional(index)} >{item}</Tag>
                })
              }
              {addtionals.length > 0 && (<br />)}
              {isAddtionalInputVisible && (
                <AutoComplete size="small"
                  options={options}
                  onBlur={(e) => addAddtional(e)}
                  onSelect={(e) => addAddtional(e)}
                  backfill={true}
                  placeholder="try to type `b`"
                  filterOption={(inputValue, option) =>
                    option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                  }
                />

              )}
              {!isAddtionalInputVisible && (
                <Tag onClick={() => setAddtionalInputVisible(true)} className="site-tag-plus">
                  <PlusOutlined /> 添加
                </Tag>
              )}
            </Form.Item>
          </Col>
        </Row>
        < Divider orientation="left" ><Button type="link" size="small">产品明细<CaretDownOutlined /></Button></Divider >
        <Row>
          <Col span={24}>
            <div style={{ padding: '0.5rem 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                <Checkbox onClick={() => setSingleSupplier(!isSingleSupplier)} style={{ width: '22rem' }} checked={isSingleSupplier} onChange={null}>单一供应商</Checkbox>
                {
                  isSingleSupplier && (
                    <Select size="small"
                      showSearch="true"
                      placeholder="请选择供应商"
                      value={supplierId}
                      onChange={(value) => onChangeSupplier(value, -1)}
                      style={{ width: '100%' }}
                    >
                      {filterSuppliers(null).map(item => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  )
                }
                {
                  isSingleSupplier && (
                    <div style={{ display: 'inline-flex' }}>
                      <Button type="link" size="small">历史合同 (10)</Button>
                      <Button type="link" size="small">总金额 ($102,222.00)</Button>

                    </div>
                  )
                }
              </div>
              <Button type="link" size="small">清空</Button>
            </div>
            <table className="goods_table" border="1">
              <thead>
                <tr>
                  <th className="th" style={{ backgroundColor: '#f0f0f0' }} width="32px">#</th>
                  <th className="th" style={{ backgroundColor: '#f0f0f0' }}>产品名称</th>
                  <th className="th" style={{ backgroundColor: '#f0f0f0' }}>规格</th>
                  <th className="th" style={{ backgroundColor: '#f0f0f0' }}>计量单位</th>
                  <th className="th" style={{ backgroundColor: '#f0f0f0' }}>订单数量</th>
                  {!isSingleSupplier && <th className="th">供应商</th>}
                  <th className="th">采购单价(￥)</th>
                  <th className="th">采购数量</th>
                  <th className="th">金额</th>
                  <th className="th">备注</th>
                </tr>
              </thead>
              <tbody>
                {
                  orderGoods.map((item, index) => {
                    return (
                      <tr>
                        <td className="td">{index + 1}</td>
                        <td className="td">{item.name}</td>
                        <td className="td">{item.spec_name}</td>
                        <td className="td" align="center" >{item.unit_name_en}</td>
                        <td className="td" align="right" >{item.count}</td>

                        {!isSingleSupplier && <td className="td">
                          <Select size="small"
                            showSearch="true"
                            placeholder="请选择供应商"
                            value={item.supplier_id}
                            onChange={(value) => onChangeSupplier(value, index)}
                            style={{ width: '100%' }}
                          >
                            {filterSuppliers(item.spec_id).map(item => (
                              <Select.Option key={item.id} value={item.id}>
                                {item.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </td>
                        }
                        <td className="td" align="right" >{item.goods_spec_price}</td>
                        <td className="td" align="right" >
                          {isSingleSupplier ? item.count : <InputNumber style={{ backgroundColor: '#FFD700' }} value={item.count} size="small" />}
                        </td>
                        <td className="td" align="right" >{((item.count * item.goods_spec_price) || 0).toFixed(2)}</td>
                        <td className="td"><Input value={item.remark} onChange={(value) => onChangeRemark(value, index)} style={{ backgroundColor: '#FFD700' }} size="small" /></td>
                      </tr>)
                  })
                }
              </tbody>
              <tfoot>
                <tr>
                  <td className="td" align="right" colspan={isSingleSupplier ? "6" : "7"}><strong>合计</strong></td>
                  <td className="td" align="right" ><strong>{sum.count}</strong></td>
                  <td className="td" align="right" ><strong>{sum.amount.toFixed(2)}</strong></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </Col>
        </Row>
        <Divider style={{ margin: '0' }} />
        <div className="page-footer">
          <Space size="large">
            <Button onClick={onClose} icon={<CloseOutlined />}>关 闭</Button>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Button htmlType="submit" type="primary" icon={<CheckOutlined />}>保 存</Button>
            </div>
          </Space>
        </div>
      </Form>
    </div >)
});
